import React from 'react';
import { AlertCircle, Slack, Twitter } from 'react-feather';
import { version as VG_VERSION } from 'vega';
import { version as VL_VERSION } from 'vega-lite';
import { version as TOOLTIP_VERSION } from 'vega-tooltip';
import isMac from '../../../utils/isMac';
import shortcuts from '../../../utils/keyboardShortcuts';
import './index.css';
// Will generate keyboard shortcuts based on OS
// 1. Check OS (isMac)
// 2. Then get the shortcuts
// 3. Map over shorcuts and render os specific
// 4. Get shortcut, split it, and map over it to render
// 5. To add shortcuts go to utils/keyboardShortcuts.ts, changes will be reflected here
const keyBoardShortcuts = shortcuts.map((shortcut, i) => (React.createElement("li", { key: i },
    (isMac() ? shortcut.mac : shortcut.windows)
        .split(' ')
        .map((key) => (key === '+' ? '+' : React.createElement("kbd", { key: `${key}${i}` }, key))),
    ": ",
    shortcut.text)));
export const COMMIT_HASH = __COMMIT_HASH__ || 'unknown';
const HelpModal = () => (React.createElement("div", { className: "help-modal" },
    React.createElement("h1", null, "Help"),
    React.createElement("h2", null, "References"),
    React.createElement("div", { className: "doc-link" },
        React.createElement("a", { href: "https://vega.github.io/vega-lite/", target: "_blank", rel: "noopener noreferrer" }, "Vega-Lite Docs")),
    React.createElement("div", { className: "doc-link" },
        React.createElement("a", { href: "https://vega.github.io/vega/", target: "_blank", rel: "noopener noreferrer" }, "Vega Docs")),
    React.createElement("h2", null, "Keyboard Shortcuts"),
    React.createElement("ul", { className: "keyboard-shortcuts" }, keyBoardShortcuts),
    React.createElement("p", null,
        "Access editor actions by clicking the Commands button or pressing ",
        React.createElement("kbd", null, "f1"),
        ".",
        React.createElement("br", null),
        "Here you can clear the spec, extract or merge the config, or format the specification."),
    React.createElement("a", { href: `https://github.com/vega/editor/issues/new?body=**Vega-Editor ${COMMIT_HASH}**`, target: "_blank", rel: "noopener noreferrer", className: "report-button button" },
        React.createElement(AlertCircle, { className: "header-icon" }),
        React.createElement("span", null, "Report a Bug")),
    React.createElement("h2", null, "Send us your feedback"),
    React.createElement("a", { href: "https://bit.ly/join-vega-slack", target: "_blank", rel: "noopener noreferrer", className: "doc-link" },
        React.createElement(Slack, { className: "doc-image" }),
        "Join our Slack channel"),
    React.createElement("a", { href: "https://twitter.com/vega_vis", target: "_blank", rel: "noopener noreferrer", className: "doc-link" },
        React.createElement(Twitter, { className: "doc-image" }),
        "Follow us on Twitter"),
    React.createElement("h2", null, "Tip"),
    React.createElement("p", null,
        "You can access Vega, Vega-Lite, and the",
        ' ',
        React.createElement("a", { href: "https://vega.github.io/vega/docs/api/view/", target: "_blank", rel: "noopener noreferrer" }, "Vega view"),
        ' ',
        "at ",
        React.createElement("code", null, "(VEGA_DEBUG)"),
        " using your browser's developer console."),
    React.createElement("h2", null, "Versions"),
    React.createElement("ul", null,
        React.createElement("li", null,
            "Vega: ",
            VG_VERSION),
        React.createElement("li", null,
            "Vega-Lite: ",
            VL_VERSION),
        React.createElement("li", null,
            "Vega-Tooltip: ",
            TOOLTIP_VERSION),
        React.createElement("li", null,
            "Editor: ",
            COMMIT_HASH))));
export default HelpModal;
